import { render, staticRenderFns } from "./WorkflowTransitionActionDetail.vue?vue&type=template&id=391ed753&"
import script from "./WorkflowTransitionActionDetail.vue?vue&type=script&lang=ts&"
export * from "./WorkflowTransitionActionDetail.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports